export const MAIN_SITE_URL = "https://kaspreadsheet.com";

export interface Category {
  key: string;
  url: string;
  icon: string;
  image: string;
}

export const CATEGORIES: Category[] = [
  {
    key: "cat.shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20premium%20white%20and%20pastel%20green%20sneakers%20placed%20on%20a%20clean%20warm%20cream%20studio%20background%20with%20soft%20natural%20lighting%2C%20minimal%20modern%20product%20photography%2C%20subtle%20soft%20shadow%2C%20fresh%20airy%20aesthetic%2C%20high%20detail%2C%20focused%20on%20the%20shoes&width=600&height=600&seq=cat-shoes&orientation=squarish",
  },
  {
    key: "cat.hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    icon: "ri-t-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20folded%20sage%20green%20oversized%20hoodie%20displayed%20on%20a%20warm%20cream%20background%20with%20gentle%20natural%20light%2C%20minimalist%20editorial%20product%20photography%2C%20soft%20shadows%2C%20clean%20fresh%20streetwear%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-hoodies&orientation=squarish",
  },
  {
    key: "cat.tshirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    icon: "ri-shirt-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20folded%20plain%20white%20cotton%20t-shirt%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20daylight%2C%20minimal%20clean%20product%20photography%2C%20subtle%20shadow%2C%20fresh%20airy%20streetwear%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-tshirts&orientation=squarish",
  },
  {
    key: "cat.jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    icon: "ri-t-shirt-2-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20olive%20green%20bomber%20jacket%20hanging%20on%20a%20wooden%20hanger%20against%20a%20warm%20cream%20wall%2C%20soft%20natural%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20clean%20streetwear%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-jackets&orientation=squarish",
  },
  {
    key: "cat.pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    icon: "ri-scissors-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20pair%20of%20neatly%20folded%20beige%20cargo%20pants%20placed%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20light%2C%20minimalist%20product%20photography%2C%20subtle%20shadow%2C%20fresh%20clean%20casual%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-pants&orientation=squarish",
  },
  {
    key: "cat.headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    icon: "ri-vip-crown-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20stylish%20pastel%20green%20baseball%20cap%20resting%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20lighting%2C%20minimal%20clean%20product%20photography%2C%20gentle%20shadow%2C%20fresh%20streetwear%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-headwear&orientation=squarish",
  },
  {
    key: "cat.sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    icon: "ri-stack-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20matching%20two%20piece%20sage%20green%20tracksuit%20set%20folded%20neatly%20on%20a%20warm%20cream%20background%20with%20soft%20daylight%2C%20minimal%20editorial%20product%20photography%2C%20subtle%20shadow%2C%20clean%20sporty%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-sets&orientation=squarish",
  },
  {
    key: "cat.underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    icon: "ri-t-shirt-air-line",
    image:
      "https://readdy.ai/api/search-image?query=Folded%20soft%20cotton%20underwear%20in%20neutral%20beige%20tones%20arranged%20on%20a%20warm%20cream%20surface%20with%20gentle%20natural%20light%2C%20minimal%20clean%20product%20photography%2C%20soft%20shadow%2C%20fresh%20airy%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-underwear&orientation=squarish",
  },
  {
    key: "cat.jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    icon: "ri-football-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20vibrant%20sports%20jersey%20with%20bold%20stripes%20displayed%20flat%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20subtle%20shadow%2C%20clean%20sporty%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-jersey&orientation=squarish",
  },
  {
    key: "cat.accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    icon: "ri-sparkling-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20collection%20of%20fashion%20accessories%20including%20a%20watch%20and%20sunglasses%20arranged%20on%20a%20warm%20cream%20surface%20with%20soft%20natural%20light%2C%20minimal%20editorial%20product%20photography%2C%20subtle%20shadows%2C%20clean%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-accessories&orientation=squarish",
  },
  {
    key: "cat.bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    icon: "ri-handbag-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20premium%20minimalist%20crossbody%20bag%20in%20warm%20taupe%20placed%20on%20a%20cream%20studio%20background%20with%20soft%20natural%20lighting%2C%20clean%20product%20photography%2C%20gentle%20shadow%2C%20fresh%20modern%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-bags&orientation=squarish",
  },
  {
    key: "cat.belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    icon: "ri-loop-left-line",
    image:
      "https://readdy.ai/api/search-image?query=A%20neatly%20coiled%20leather%20belt%20in%20warm%20brown%20tones%20on%20a%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20product%20photography%2C%20subtle%20shadow%2C%20clean%20refined%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-belts&orientation=squarish",
  },
  {
    key: "cat.perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    icon: "ri-drop-line",
    image:
      "https://readdy.ai/api/search-image?query=An%20elegant%20glass%20perfume%20bottle%20with%20soft%20amber%20liquid%20on%20a%20warm%20cream%20surface%20with%20gentle%20natural%20lighting%2C%20minimal%20editorial%20product%20photography%2C%20subtle%20shadow%2C%20fresh%20sophisticated%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-perfumes&orientation=squarish",
  },
  {
    key: "cat.other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    icon: "ri-more-2-line",
    image:
      "https://readdy.ai/api/search-image?query=An%20assorted%20flat%20lay%20of%20various%20fashion%20accessories%20and%20small%20items%20arranged%20on%20a%20warm%20cream%20background%20with%20soft%20natural%20light%2C%20minimal%20product%20photography%2C%20subtle%20shadows%2C%20clean%20aesthetic%2C%20high%20detail&width=600&height=600&seq=cat-other&orientation=squarish",
  },
];